import styled from "styled-components";

export const Wrapper = styled.div`
    background: #000000;
    padding: 0 5px;
`;

export const Content = styled.div`
  padding: 5px;
  max-width: var(--maxWidth);
  margin: 0 auto;
`;

export const Text = styled.div`
width: 100%;
text-align: center;
color:  var(--white);
height: 50px;
`;
